var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 12C24.0002 18.6276 18.6278 24 12.0002 24C5.37288 24 0.000244141 18.6276 0.000244141 12C0.000244141 5.37252 5.37288 0 12.0002 0C18.6278 0 24.0002 5.37252 24.0002 12Z",
    fill: "#1BA27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6321 6.05103H6.26929V8.79423H10.5791V12.8262H13.3223V8.79423H17.6321V6.05103Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.977 13.256C8.41179 13.256 5.52135 12.6917 5.52135 11.9956C5.52135 11.2996 8.41167 10.7352 11.977 10.7352C15.5422 10.7352 18.4325 11.2996 18.4325 11.9956C18.4325 12.6917 15.5422 13.256 11.977 13.256ZM19.2256 12.2057C19.2256 11.3081 15.9803 10.5806 11.977 10.5806C7.97379 10.5806 4.72827 11.3081 4.72827 12.2057C4.72827 12.9962 7.24479 13.6547 10.5795 13.8006V19.5887H13.3224V13.8029C16.6828 13.6616 19.2256 13.0002 19.2256 12.2057Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.93d1c379faee867e1c7eb1cabbe341e7.svg";
export { ForwardRef as ReactComponent };